module.exports = {
      id: "ic-line-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-line-usage",
      toString: function () {
        return this.url;
      }
    }